import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { hideTokenExpiredDialog, resetTokenExpired } from '../redux/slices/authSlice';

const TokenExpiredDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showTokenExpiredDialog } = useSelector((state) => state.auth);

  const handleOk = () => {
    dispatch(hideTokenExpiredDialog());
    dispatch(resetTokenExpired());
    // Chuyển đến trang đăng nhập
    navigate('/login');
  };

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ExclamationCircleOutlined style={{ color: '#faad14' }} />
          Phiên đăng nhập hết hạn
        </div>
      }
      open={showTokenExpiredDialog}
      onOk={handleOk}
      onCancel={handleOk}
      okText="OK"
      cancelButtonProps={{ style: { display: 'none' } }}
      closable={false}
      maskClosable={false}
      centered
    >
      <p>Phiên đăng nhập của bạn đã hết hạn. Vui lòng đăng nhập lại để tiếp tục sử dụng.</p>
    </Modal>
  );
};

export default TokenExpiredDialog;
